import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper'
import Switch from '@material-ui/core/Switch';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import GridRegistro from '../components/GridRegistro'

import api from '../services/api'
import consultaCep from '../services/consultaCep'
import { paramsToObject, validarCPF, onlyNumbers, formToObject, populateForm, objectToQueryString } from '../utils/functions'
import { mCPF, mTel, mCEP } from '../utils/masks'

import './styles/RegSuppliers.css';
import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import Tabs from '../components/Tabs';
import { FormCheck } from 'react-bootstrap';

const swal = withReactContent(Swal)

function Parceiros() {
    const [data, setData] = useState({})
    const [replicaEndereco, setReplicaEndereco] = useState(false)
    const [erroCpf, setErroCpf] = useState(false)
    const [erroCpfResponsavel, setErroCpfResponsavel] = useState(false)
    const [erroCep, setErroCep] = useState(false)
    const [erroEmail, setErroEmail] = useState(false)
    const [updateType, setUpdateType] = useState(false)
    const [comboCidades, setComboCidades] = useState([{ value: '', display: '' }])
    const [comboEstados, setComboEstados] = useState([{ value: '', display: '' }])
    const [comboCidadesCob, setComboCidadesCob] = useState([{ value: '', display: '' }])
    const [blockCidadesCob, setBlockCidadesCob] = useState(true)
    const [blockCidades, setBlockCidades] = useState(true)
    const [enableAdd, setenableAdd] = useState('N')

    const [currentUser, setCurrentUser] = useState(null)

    const [filter, setFilter] = useState({})
    const [filtered, setFiltered] = useState(false)
    const [nome, setNome] = useState('')
    const [setor, setSetor] = useState('')
    const [fone1, setFone1] = useState('')
    const [fone2, setFone2] = useState('')
    const [email, setEmail] = useState('')
    const [observacao, setObservacao] = useState('')
    const [inativo, setInativo] = useState('')

    const [dataCon, setDataCon] = useState([{ value: '', display: '' }])
    const [modal, setModal] = useState(false)
    const [updatemodal, setUpdateModal] = useState(false)
    const [pkModal, setPkModal] = useState('')

    const columns = [
        { id: 'NOME', numeric: false, label: 'Nome', align: 'left', minWidth: 100 },
        { id: 'SETOR', numeric: false, label: 'Setor', align: 'left', minWidth: 100 },
        { id: 'FONE1', numeric: true, label: 'Telefone 1', align: 'left', minWidth: 100 },
        { id: 'FONE2', numeric: true, label: 'Telefone 2', align: 'left', minWidth: 100 },
        { id: 'EMAIL', numeric: false, label: 'E-mail', align: 'left', minWidth: 100 },
        { id: 'OBSERVACAO', numeric: false, label: 'Observação', align: 'left', minWidth: 100 },
        { id: 'INATIVO', numeric: false, label: 'Inativo', align: 'left', minWidth: 100 }
    ]

    useEffect(() => {
        const fetchData = async () => {
            swal.fire({
                html: <FrLoading text="Carregando..." />,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            })
            const urlParams = new URLSearchParams(window.location.search);
            let query = paramsToObject(urlParams)
            let strAuth = localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })
            let auth = JSON.parse(strAuth)
            setCurrentUser(auth.user)

            setComboEstados(await api.getComboData('estados'))

            api.get('/parceiro_venda?pk_uex=' + auth.user).then(r => {
                console.log(r.data)
                setUpdateType(true)
                setData(r.data[0])
                api.get('/parceiro_venda/contatos?pk_cad=' + r.data[0].PK_CAD).then(r => {
                    if (r.data.length > 0)
                        setDataCon(r.data)
                })
                swal.close()
            })
        }



        fetchData()
    }, [])

    function mostraModal(e) {
        e.preventDefault()
        setNome('')
        setSetor('')
        setFone1('')
        setFone2('')
        setEmail('')
        setObservacao('')
        setInativo('')
        setUpdateModal(false)
        setModal(true)
    }

    function closeModal(e) {
        e.preventDefault()
        setModal(false)
    }

    function handleSubmitModal(e) {
        e.preventDefault()
        if (!nome || !email || !fone1) {
            swal.fire({
                title: 'Erro!',
                text: "Informe o nome, e-mail e pelo menos um telefone.",
                icon: 'warning',
            })


        } else {
            if (!updatemodal)
                incluiCon(e)
            else
                updateCon(e)
            closeModal(e)
        }
    }

    function incluiCon(e) {
        e.preventDefault();
        let pk = 1
        console.log(dataCon)
        if (!dataCon[0].PK) {
            setDataCon([{
                NOME: nome,
                SETOR: setor,
                FONE1: fone1,
                FONE2: fone2,
                EMAIL: email,
                OBSERVACAO: observacao,
                INATIVO: inativo,
                PK: pk
            }])

        } else {
            let item = [{
                NOME: dataCon[0].NOME,
                SETOR: dataCon[0].SETOR,
                FONE1: dataCon[0].FONE1,
                FONE2: dataCon[0].FONE2,
                EMAIL: dataCon[0].EMAIL,
                OBSERVACAO: dataCon[0].OBSERVACAO,
                INATIVO: dataCon[0].INATIVO,
                PK: pk
            }]

            pk++
            var i;
            for (i = 1; i < dataCon.length; i++) {
                item.push({
                    NOME: dataCon[i].NOME,
                    SETOR: dataCon[i].SETOR,
                    FONE1: dataCon[i].FONE1,
                    FONE2: dataCon[i].FONE2,
                    EMAIL: dataCon[i].EMAIL,
                    OBSERVACAO: dataCon[i].OBSERVACAO,
                    INATIVO: dataCon[i].INATIVO,
                    PK: pk
                })
                pk++

            }
            item.push({
                NOME: nome,
                SETOR: setor,
                FONE1: fone1,
                FONE2: fone2,
                EMAIL: email,
                OBSERVACAO: observacao,
                INATIVO: inativo,
                PK: pk

            })
            pk++
            setDataCon(item)
        }
    }


    function updateCon(e) {
        e.preventDefault();

        let item = []
        let i


        for (i = 0; i < dataCon.length; i++) {
            if (dataCon[i].PK == pkModal) {
                console.log(pkModal)
                item.push({
                    NOME: nome,
                    SETOR: setor,
                    FONE1: fone1,
                    FONE2: fone2,
                    EMAIL: email,
                    OBSERVACAO: observacao,
                    INATIVO: inativo,
                    PK: pkModal,
                })
            } else {
                item.push({
                    NOME: dataCon[i].NOME,
                    SETOR: dataCon[i].SETOR,
                    FONE1: dataCon[i].FONE1,
                    FONE2: dataCon[i].FONE2,
                    EMAIL: dataCon[i].EMAIL,
                    OBSERVACAO: dataCon[i].OBSERVACAO,
                    INATIVO: dataCon[i].INATIVO,
                    PK: dataCon[i].PK,
                })
            }

            if (i + 1 == dataCon.length)
                setDataCon(item)
        }

    }


    useEffect(() => {
        const fetchCidades = async () => {
            if (data.FK_EST > 0) {
                swal.fire({
                    html: <FrLoading text="Buscando Cidades..." />,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })


                const urlParams = new URLSearchParams(window.location.search);
                let query = paramsToObject(urlParams)
                let strAuth = localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })
                let auth = JSON.parse(strAuth)
                setCurrentUser(auth.user)


                let cidades = await api.getComboData('cidades', data.FK_EST)
                setComboCidades(cidades)
                if (data.CIDADE_CEP) {
                    let cidade = cidades.find(item => String(item.display).normalize('NFD').replace(/[\u0300-\u036f]/g, "") === data.CIDADE_CEP.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
                    if (cidade) {
                        const auxValues = { ...data };
                        auxValues['FK_CID'] = cidade.value
                        if (replicaEndereco) {
                            auxValues['CEP_COB'] = auxValues['CEP_COB']
                            auxValues['END_COB'] = auxValues['ENDERECO']
                            auxValues['NUMERO_COB'] = auxValues['NUMERO']
                            auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
                            auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
                            auxValues['FK_EST_COB'] = auxValues['FK_EST']
                            auxValues['FK_CID_COB'] = auxValues['FK_CID']
                        }
                        setData(auxValues)
                    }
                }

                swal.close()
                setBlockCidades(false)
            } else setBlockCidades(true)
        }

        fetchCidades()
    }, [data.FK_EST])


    useEffect(() => {
        const fetchCidadesCob = async () => {
            if (data.FK_EST_COB > 0) {
                swal.fire({
                    html: <FrLoading text="Buscando Cidades..." />,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                let cidades = await api.getComboData('cidades', data.FK_EST_COB)
                setComboCidadesCob(cidades)

                if (data.CIDADE_COB_CEP) {
                    let cidade = cidades.find(item => String(item.display).normalize('NFD').replace(/[\u0300-\u036f]/g, "") === data.CIDADE_COB_CEP.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
                    if (cidade) {
                        const auxValues = { ...data };
                        auxValues['FK_CID_COB'] = cidade.value
                        setData(auxValues)
                    }
                }
                swal.close()
                setBlockCidadesCob(false)
            } else setBlockCidadesCob(true)
        }

        fetchCidadesCob()
    }, [data.FK_EST_COB])

    async function handleCpf(e) {
        e.preventDefault();
        if (!validarCPF(e.target.value) && (String(e.target.value) !== '')) {
            switch (e.target.name) {
                case 'CPF': setErroCpf(true)
            }
            swal.fire('CPF inválido', 'Informe um CPF válido!', 'warning')
        } else {
            switch (e.target.name) {
                case 'CPF':
                    setErroCpf(false)
                    if (String(e.target.value) !== '') {
                        await api.get('parceiro_venda?cpf_existente=' + e.target.value).then(r => {
                            if (r.data.length > 0) {
                                setErroCpf(true)
                                swal.fire('CPF inválido', 'Já existe parceiro ativo para este CPF!', 'warning')
                            }
                        })
                    }
                    break
                case 'CPF_RESPONSAVEL': setErroCpfResponsavel(false)
            }

            if ((e.target) && (e.target.name == 'CPF')) {
                api.get('/parceiro_venda/temPropostaAtiva?CPF=' + e.target.value).then(r => {
                    if (r.data) {
                        swal.fire(r.data)
                    }
                })
            }
        }
    }

    function handleEmail(e) {
        e.preventDefault();
        if (e.target.value) {
            if (e.target.value.indexOf('@') === -1) {
                setErroEmail(true)
                swal.fire('Email inválido', 'Informe um email válido!', 'warning')
            } else setErroEmail(false)
        }
    }

    function handleCep(e) {
        e.preventDefault();
        if (e.target.value) {
            if (e.target.value) {
                swal.fire({
                    html: <FrLoading text="Buscando CEP..." />,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                consultaCep.get('/' + onlyNumbers(e.target.value) + '/json').then(r => {
                    console.log(r)
                    if (r.data.erro) {
                        setErroCep(true)
                        swal.close()
                        swal.fire('CEP inválido', 'Informe um CEP válido!', 'warning')
                    } else {
                        setErroCep(false)
                        const auxValues = { ...data };
                        auxValues['ENDERECO'] = r.data.logradouro;
                        auxValues['BAIRRO'] = r.data.bairro;
                        let estado = comboEstados.find((item) => item.UF === r.data.uf)
                        if (estado) auxValues['FK_EST'] = estado.value
                        auxValues['CIDADE_CEP'] = String(r.data.localidade).toUpperCase()
                        if (replicaEndereco) {
                            auxValues['CEP_COB'] = auxValues['CEP_COB']
                            auxValues['END_COB'] = auxValues['ENDERECO']
                            auxValues['NUMERO_COB'] = auxValues['NUMERO']
                            auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
                            auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
                            auxValues['FK_EST_COB'] = auxValues['FK_EST']
                            auxValues['FK_CID_COB'] = auxValues['FK_CID']
                        }
                        // let cidade = comboCidades.find((item) => item.display.toUpperCase() === r.data.cidade.toUpperCase())
                        // auxValues['FK_CID'] = cidade.value
                        swal.close()
                        setData(auxValues)
                    }
                }).catch(err => {
                    setErroCep(true)
                    swal.close()
                    swal.fire('CEP inválido', 'Informe um CEP válido!', 'warning')
                })
            }
        }
    }

    function consistData(data) {
        let required = [
            'RAZAO_SOCIAL', 'NOMEFANTASIA', 'CEP', 'ENDERECO', 'NUMERO', 'BAIRRO', 'FK_EST', 'FK_CID', 'CELULAR', 'EMAIL'
        ]

        let errors = []

        required.forEach((curr, index) => {
            let fieldName = curr

            if (fieldName === 'RAZAO_SOCIAL') fieldName = "Razão Social";
            if (fieldName === 'NOMEFANTASIA') fieldName = "Nome Fantasia";
            if (fieldName === 'ENDERECO') fieldName = "Endereço";
            if (fieldName === 'NUMERO') fieldName = "Número";
            if (fieldName === 'BAIRRO') fieldName = "Bairro";
            if (fieldName === 'FK_EST') fieldName = "Estado";
            if (fieldName === 'FK_CID') fieldName = "Cidade";
            if (fieldName === 'CELULAR') fieldName = "Celular";
            if (fieldName === 'EMAIL') fieldName = "E-mail";

            if (!data[curr]) return errors.push(fieldName)
        });

        return errors
    }

    function handleSubmit(e) {
        e.preventDefault();

        swal.fire({
            title: 'ATENÇÃO',
            text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                const auxValues = { ...data };
                let errors = consistData(auxValues)
                if (errors.length === 0) {
                    auxValues.contatos = dataCon
                    api.post('/parceiro_venda/edit', auxValues).then(r => {
                        if (r.status === 200) {
                            swal.fire({
                                title: 'Registro Alterado',
                                text: "O registro foi alterado com sucesso!",
                                icon: 'success',
                            }).then((result) => {
                                if (result.value) {
                                    window.history.back()
                                }
                            })
                        } else {
                            swal.fire({
                                title: 'Erro!',
                                text: "O registro não foi alterado!",
                                icon: 'warning',
                            })
                        }
                    })
                } else {
                    swal.fire({
                        title: 'Erro!',
                        text: "Verifique o(s) campo(s): " + errors.join(', '),
                        icon: 'warning',
                    })
                }
            }
        })

    }


    function handleCancel(e) {
        e.preventDefault();
        if (!updateType) {
            swal.fire({
                title: 'ATENÇÃO',
                text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    window.history.back()
                }
            })
        } else window.history.back()
    }


    const handleChangeModal = (e) => {
        switch (e.target.name) {
            case 'nome':
                setNome(e.target.value)
                break

            case 'setor':
                setSetor(e.target.value)
                break

            case 'fone1':
                setFone1(e.target.value)
                break

            case 'fone2':
                setFone2(e.target.value)
                break

            case 'email':
                setEmail(e.target.value)
                break

            case 'observacao':
                setObservacao(e.target.value)
                break

            case 'inativo':
                setInativo(e.target.value)
                break
        };
    }



    const handleChange = (e) => {
        const auxValues = { ...data };
        switch (e.target.name) {
            case 'CPF':
                auxValues[e.target.name] = mCPF(e.target.value)
                break

            case 'FONE1':
            case 'FONE2':
            case 'CELULAR':
            case 'FONE_RESPONSAVEL':
                auxValues[e.target.name] = mTel(e.target.value)
                break

            case 'CEP':
            case 'CEP_COB':
                auxValues[e.target.name] = mCEP(e.target.value)
                if (replicaEndereco) {
                    auxValues['CEP_COB'] = auxValues['CEP']
                }
                break

            default:
                auxValues[e.target.name] = e.target.value
                if (typeof (e.target.value) === 'string') auxValues[e.target.name] = e.target.value.toUpperCase()
                if (replicaEndereco) {
                    auxValues['END_COB'] = auxValues['ENDERECO']
                    auxValues['NUMERO_COB'] = auxValues['NUMERO']
                    auxValues['COMPLEMENTO_COB'] = auxValues['COMPLEMENTO']
                    auxValues['BAIRRO_COB'] = auxValues['BAIRRO']
                    auxValues['FK_EST_COB'] = auxValues['FK_EST']
                    auxValues['FK_CID_COB'] = auxValues['FK_CID']
                }
                break
        }

        setData(auxValues);
    };

    return (
        <div className="defaultReg" >
            <NavBar />
            <div className="defaultRegContent">
                <div className="defaultHeader">
                    <h1>Cadastro de Parceiros</h1>
                    <UserOptions />
                </div>
                <br />
                <form id="regForm" onSubmit={""}>

                    <Tabs aba1_caption="EDIÇÃO DE CADASTRO" aba1_hidden={false} Aba1={
                        <div>
                            <h2>Dados Cadastrais: </h2>
                            <FrTextInput
                                maxLength='150'
                                value={data.RAZAO_SOCIAL || ''}
                                onChange={handleChange}
                                name="RAZAO_SOCIAL"
                                id="RAZAO_SOCIAL"
                                color="#F1873B"
                                label="Razão Social"
                                variant="outlined"
                                size="small"
                                required
                                style={{ width: 420 }}
                            />

                            <FrTextInput
                                maxLength='150'
                                value={data.NOMEFANTASIA || ''}
                                onChange={handleChange}
                                name="NOMEFANTASIA"
                                id="NOMEFANTASIA"
                                color="#F1873B"
                                label="Nome Fantasia"
                                variant="outlined"
                                size="small"
                                required
                                style={{ width: 420 }}
                            />
                            <br />
                            <FrTextInput
                                maxLength='14'
                                value={data.CNPJ || ''}
                                onChange={handleChange}
                                onBlur={handleCpf}
                                name="CNPJ"
                                id="CNPJ"
                                color="#F1873B"
                                label="CNPJ"
                                variant="outlined"
                                size="small"
                                disabled={updateType}
                                required
                                style={{ width: 180 }}
                            />

                            <FrTextInput
                                error={erroCpf}
                                maxLength='14'
                                value={data.CPF || ''}
                                onChange={handleChange}
                                onBlur={handleCpf}
                                name="CPF"
                                id="CPF"
                                color="#F1873B"
                                label="CPF"
                                variant="outlined"
                                size="small"
                                disabled={updateType}
                                required
                                style={{ width: 180 }}
                            />

                            <FrTextInput
                                maxLength='14'
                                value={data.INSC_EST || ''}
                                onChange={handleChange}
                                name="INSC_EST"
                                id="INSC_EST"
                                color="#F1873B"
                                label="Inscrição Estadual"
                                variant="outlined"
                                size="small"
                                style={{ width: 180 }}
                            />

                            <FrTextInput
                                maxLength='14'
                                value={data.INSC_MUN || ''}
                                onChange={handleChange}
                                name="INSC_MUN"
                                id="INSC_MUN"
                                color="#F1873B"
                                label="Inscrição Municipal"
                                variant="outlined"
                                size="small"
                                style={{ width: 180 }}
                            />
                            <FrTextInput
                                maxLength='10'
                                value={data.CEP || ''}
                                error={erroCep}
                                onChange={handleChange}
                                onBlur={handleCep}
                                name="CEP"
                                id="CEP"
                                color="#F1873B"
                                label="CEP"
                                variant="outlined"
                                size="small"
                                style={{ width: 100 }}
                                required
                            // disabled={updateType}
                            />
                            <br />
                            <FrTextInput
                                maxLength='100'
                                value={data.ENDERECO || ''}
                                onChange={handleChange}
                                fullWidth
                                name="ENDERECO"
                                id="ENDERECO"
                                color="#F1873B"
                                label="Rua"
                                variant="outlined"
                                size="small"
                                style={{ width: 550 }}
                                required
                            // disabled={updateType}
                            />
                            <FrTextInput
                                maxLength='45'
                                value={data.NUMERO || ''}
                                onChange={handleChange}
                                name="NUMERO"
                                id="NUMERO"
                                color="#F1873B"
                                label="Número"
                                variant="outlined"
                                size="small"
                                required
                                style={{ width: 100 }}
                            // disabled={updateType}
                            />
                            <FrTextInput
                                maxLength='30'
                                value={data.COMPLEMENTO || ''}
                                onChange={handleChange}
                                name="COMPLEMENTO"
                                id="COMPLEMENTO"
                                color="#F1873B"
                                label="Complemento"
                                variant="outlined"
                                size="small"
                                style={{ width: 120 }}
                            // disabled={updateType}
                            />
                            <br />
                            <FrTextInput
                                maxLength='45'
                                value={data.BAIRRO || ''}
                                onChange={handleChange}
                                name="BAIRRO"
                                id="BAIRRO"
                                color="#F1873B"
                                label="Bairro"
                                variant="outlined"
                                size="small"
                                required
                                style={{ width: 200 }}
                            // disabled={updateType}
                            />

                            <FrSelect
                                value={data.FK_EST || ''}
                                onChange={handleChange}
                                name="FK_EST"
                                id="FK_EST"
                                label='Estado *'
                                data={comboEstados}
                                style={{ width: 250 }}
                            // disabled={updateType}
                            />
                            <Tooltip title={blockCidades ? 'Informe um Estado antes de informar a Cidade!' : ''}>
                                <FrSelect
                                    value={data.FK_CID || ''}
                                    onChange={handleChange}
                                    name="FK_CID"
                                    id="FK_CID"
                                    label='Cidade *'
                                    data={comboCidades}
                                    style={{ width: 300 }}
                                    disabled={blockCidades}
                                    required
                                // disabled={updateType}
                                />
                            </Tooltip>
                            <br />
                            <FrTextInput
                                maxLength='14'
                                value={data.FONE1 || ''}
                                onChange={handleChange}
                                name="FONE1"
                                id="FONE1"
                                color="#F1873B"
                                label="Telefone 1"
                                variant="outlined"
                                size="small"
                                style={{ width: 160 }}

                            // disabled={updateType}
                            />
                            <FrTextInput
                                maxLength='14'
                                value={data.FONE2 || ''}
                                onChange={handleChange}
                                name="FONE2"
                                id="FONE2"
                                color="#F1873B"
                                label="Telefone 2"
                                variant="outlined"
                                size="small"
                                style={{ width: 160 }}

                            // disabled={updateType}
                            />
                            <FrTextInput
                                maxLength='14'
                                value={data.CELULAR || ''}
                                onChange={handleChange}
                                name="CELULAR"
                                id="CELULAR"
                                color="#F1873B"
                                label="Celular"
                                variant="outlined"
                                style={{ width: 160 }}
                                size="small"
                                // disabled={updateType}
                                required
                            />
                            <FrTextInput
                                maxLength='50'
                                value={data.EMAIL || ''}
                                onChange={handleChange}
                                onBlur={handleEmail}
                                name="EMAIL"
                                id="EMAIL"
                                color="#F1873B"
                                label="Email"
                                variant="outlined"
                                size="small"
                                style={{ width: 300 }}
                                required
                            // disabled={updateType}
                            />
                        </div>
                    }
                        aba2_caption="REGISTRO DE CONTATOS" aba2_hidden={false} Aba2={


                            <div className="grupoEdits">
                                <button onClick={(e) => mostraModal(e)}>
                                    <Icon icon={ic_add_box} size={18} />
                                    Incluir
                                </button>


                                <div className="manutReg">
                                    <GridRegistro setModal={setModal} setUpdateModal={setUpdateModal} editar={true} setPkModal={setPkModal} setDataGrid={setDataCon} setNome={setNome} setSetor={setSetor} setFone1={setFone1} setFone2={setFone2} detail regName="" columns={columns} searched={false} codeName="PK" page={''} data={dataCon} />
                                    <div className="register" hidden={!modal}>

                                        <div className="fields">
                                            <FrTextInput
                                                maxLength='75'
                                                value={nome || ''}
                                                onChange={handleChangeModal}
                                                name="nome"
                                                id="nome"
                                                color="#49573B"
                                                label="Nome"
                                                variant="outlined"
                                                size="small"
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <FrTextInput
                                                maxLength='50'
                                                value={setor || ''}
                                                onChange={handleChangeModal}
                                                name="setor"
                                                id="setor"
                                                color="#49573B"
                                                label="Setor"
                                                variant="outlined"
                                                size="small"
                                                style={{ width: 200 }}
                                            />
                                            <FrTextInput
                                                maxLength='11'
                                                value={fone1 || ''}
                                                onChange={handleChangeModal}
                                                name="fone1"
                                                id="fone1"
                                                color="#49573B"
                                                label="Telefone 1"
                                                variant="outlined"
                                                size="small"
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <FrTextInput
                                                maxLength='11'
                                                value={fone2 || ''}
                                                onChange={handleChangeModal}
                                                name="fone2"
                                                id="fone2"
                                                color="#49573B"
                                                label="Telefone 2"
                                                variant="outlined"
                                                size="small"
                                                style={{ width: 200 }}
                                            />
                                            <FrTextInput
                                                maxLength='30'
                                                value={email || ''}
                                                onChange={handleChangeModal}
                                                name="email"
                                                id="email"
                                                color="#49573B"
                                                label="E-mail"
                                                variant="outlined"
                                                size="small"
                                                style={{ width: 200 }}
                                                required
                                            />
                                            <FrSelect
                                                value={inativo || ''}
                                                onChange={handleChangeModal}
                                                name="inativo"
                                                id="inativo"
                                                color="#49573B"
                                                label="Inativo"
                                                variant="outlined"
                                                size="small"
                                                style={{ width: 200 }}
                                                data={[{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }]}
                                            />
                                            <FrTextInput
                                                maxLength='100'
                                                value={observacao || ''}
                                                onChange={handleChangeModal}
                                                name="observacao"
                                                id="observacao"
                                                color="#49573B"
                                                label="Observação"
                                                variant="filled"
                                                size="small"
                                                multiline
                                                rows="4"
                                                rowsMax="4"
                                                style={{ width: 200 }}
                                            />

                                        </div>
                                        <div className="regButtonsDiv">
                                            <button onClick={handleSubmitModal}>Salvar</button>
                                            <button onClick={closeModal}>Cancelar</button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        }
                    >
                    </Tabs>
                </form>
                <div className="regButtonsDiv">
                    <button style={{ display: 'block' }} onClick={handleSubmit}>Salvar</button>
                    <button onClick={handleCancel}>{updateType ? 'Voltar' : 'Cancelar'}</button>
                </div>
                <FooterDelphus />
            </div >
        </div >
    );
}

export default Parceiros;